<template>
  <div class="jinluo-container">
    <div class="jinluo-content">
      <label class="jinluo-name-label jinluo-content-sub">
        {{ currentJinLuoName }}
      </label>
      <label class="shicheng-label jinluo-content-sub">
        {{ currentShiCheng }}
      </label>
      <label class="current-time-label jinluo-content-sub">
        {{ currentTime.getFullYear() }}年{{
          currentTime.getMonth()
        }}月{{ currentTime.getDay() }}日{{
          currentTime.getHours()
        }}:{{ currentTime.getMinutes().toString().padStart(2, "0") }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JinLuoCurrentTime',
  components: {},
  props: {},
  data() {
    return {
      currentTime: new Date(),
      currentJinLuoName: '足少阴肾经',
      currentShiCheng: '',
    };
  },
  methods: {
    jingLuoData: function (time) {
      let shiCheng = '';
      let jingLuoName = '';
      switch (time) {
        case 23:
        case 0:
          shiCheng = '子时23-1点';
          jingLuoName = '足少阴肾经';
          break;
        case 1:
        case 2:
          jingLuoName = '足少阴肾经';
          shiCheng = '丑时1-3点';
          break;
        case 3:
        case 4:
          jingLuoName = '足少阴肾经';
          shiCheng = '寅时3-5点';
          break;
        case 5:
        case 6:
          jingLuoName = '足少阴肾经';
          shiCheng = '卯时5-7点';
          break;
        case 7:
        case 8:
          jingLuoName = '足少阴肾经';
          shiCheng = '辰时7-9点';
          break;
        case 9:
        case 10:
          jingLuoName = '足少阴肾经';
          shiCheng = '巳时9-11点';
          break;
        case 11:
        case 12:
          jingLuoName = '足少阴肾经';
          shiCheng = '午时11-13点';
          break;
        case 13:
        case 14:
          jingLuoName = '足少阴肾经';
          shiCheng = '未时13-15点';
          break;
        case 15:
        case 16:
          jingLuoName = '足少阴肾经';
          shiCheng = '申时15-17点';
          break;
        case 17:
        case 18:
          jingLuoName = '足少阴肾经';
          shiCheng = '酉时17-19点';
          break;
        case 19:
        case 20:
          jingLuoName = '足少阴肾经';
          shiCheng = '戌时19-21点';
          break;
        case 21:
        case 22:
          jingLuoName = '足少阴肾经';
          shiCheng = '亥时21-23点';
          break;
      }
      return {
        shiCheng,
        jingLuoName,
      };
    }
  },
  mounted() {
    let that = this;
    let currentDateTime = this.currentTime = new Date();
    let currentTimeData = this.jingLuoData(currentDateTime.getHours());
    this.currentJinLuoName = currentTimeData.jingLuoName;
    this.currentShiCheng = "(" + currentTimeData.shiCheng + ")";
    this.currentDateTimer = setInterval(function () {
      currentDateTime = this.currentTime = new Date();
      currentTimeData = that.jingLuoData(currentDateTime.getHours());
      that.currentJinLuoName = currentTimeData.jingLuoName;
      that.currentShiCheng = "(" + currentTimeData.shiCheng + ")";
    }, 1000)
  },
  destroyed() {
    if (this.currentDateTimer) {
      clearInterval(this.currentDateTimer);
    }
  }
}
</script>

<style scoped>
.jinluo-container {
  color: #c8c8c8;
  position: absolute;
  right: 10%;
  top: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/image/mainPage/JingLuoTimeBorder.png");
  background-size: 100% 100%;
}

.jinluo-content {
  margin: 1.2vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
}

.jinluo-content-sub {
  margin-bottom: 1.2vw;
  margin-left: 1.2vw;
  margin-right: 1.2vw;
  font-family: "PingFang", serif;
}

.jinluo-name-label {
  color: #0fffff;
  font-size: 4vw;
}

.shicheng-label {
  font-size: 3vw;
}

.current-time-label {
  border-top: dashed;
  font-size: 3.5vw;
}
</style>
